import * as CubeTree from '../../cubeTree';
import CodiSystem from '../../codiSystem';
import FrontCubeData from '../../frontCubeData';
import Utils from '../../utils/util';

function makeOverflowMoveTask(cols: CubeId[][], targetFreezer: CubeId): MoveTask {
    let result: MoveTask = {
        logic: [],
        physics: []
    };

    result.logic = makeLogicTask(cols, targetFreezer);
    result.physics = makePhysicsTask(cols, targetFreezer);

    return result;
}

function makeLogicTask(cols: CubeId[][], targetFreezer: CubeId): LogicMoveTask[] {
    let result: LogicMoveTask[] = [];
    let cabinet: CubeId = CubeTree.findFreezersCabinet(targetFreezer);
    let targetCube: CubeId|null = CubeTree.findFirstCubeInFreezer(targetFreezer);

    cols.forEach((cubes: CubeId[]): void => {
        cubes.forEach((cubeId: CubeId): void => {
            let oldParent: CubeId|null = CubeTree.findParentIdByCubeId(cubeId);

            result.push({
                from: {
                    parent: oldParent,
                    moveTarget: cubeId,
                    before: null
                },
                to: {
                    parent: cabinet,
                    moveTarget: cubeId,
                    insertBefore: targetCube
                }
            });
        });
    });

    return result;
}

function makePhysicsTask(cols: CubeId[][], targetFreezer: CubeId): PhysicsMoveTask[] {
    let result: PhysicsMoveTask[] = [];
    let dis: number = 0;
    let firstTargetCube: CubeId|null = CubeTree.findFirstCubeInFreezer(targetFreezer);
    let left: PhysicsMeasurement = 0;
    let colStep: number = 0.01;

    if (firstTargetCube) {
        left = FrontCubeData.getNumberValue(firstTargetCube, 'posX');
    }

    for (let i = cols.length - 1; i >= 0; i--) {
        dis = Utils.math(dis, colStep, '+');
        left = Utils.math(left, dis, '-');

        cols[i].forEach((cubeId: CubeId): void => {
            result.push({
                from: {
                    moveTarget: cubeId,
                    position: {
                        left: 0,
                        bottom: 0
                    }
                },
                to: {
                    moveTarget: cubeId,
                    position: {
                        left: left,
                        bottom: 0
                    }
                }
            });
        });
    }

    return result;
}

export {
    makeOverflowMoveTask
};
